import Model, { attr, belongsTo } from '@ember-data/model';
import { cached } from '@glimmer/tracking';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class PromotionRedemptionModel extends Model {
  @attr('date') createdAt!: Date;

  @belongsTo('booking', { inverse: null, async: false })
  booking!: ModelRegistry['booking'];

  @cached
  get discountAmount(): number | undefined {
    const { price } = this.booking;

    if (!price?.discounts) {
      return;
    }

    const discount = price.discounts.find(
      (discount) => discount.type === 'promotion',
    ) as ModelRegistry['extra-price'];

    return discount?.amount;
  }
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'promotion-redemption': PromotionRedemptionModel;
  }
}
